import { NgxSmartModalModule } from 'ngx-smart-modal';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-generic-smart-modal',
  templateUrl: './generic-smart-modal.component.html',
  styleUrls: ['./generic-smart-modal.component.scss']
})
export class GenericSmartModalComponent implements OnInit {
  @Input() modalId: string;
  @Input() title: string;
  @Input() description: string;
  @Input() showButtons = true;
  @Input() buttonOkDisabled = false;

  @Output() onClose: EventEmitter<any> = new EventEmitter();
  @Output() onOpen: EventEmitter<any> = new EventEmitter();
  @Output() onOkClick: EventEmitter<any> = new EventEmitter();
  @Output() onCancelClick: EventEmitter<any> = new EventEmitter();

  constructor() {}

  ngOnInit() {
    if (!this.modalId) {
      console.error('No se ha defindo el Id de la ventana modal.');
    }
  }

  onCloseModal() {
    this.onClose.emit(null);
  }

  onOpenModal() {
    this.onOpen.emit(null);
  }

  onBtnAceptarClick() {
    this.onOkClick.emit();
  }

  onBtnCancelarClick() {
    this.onCancelClick.emit();
  }
}
